import Vue from "vue";
import qs from "qs";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL + "/api/v1";
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function(params) {
      return qs.stringify(params, { encode: false });
    }
  };

  const requestUrl = params.customer_id
    ? `${url}/customers/${params.customer_id}/relationships/tasks`
    : `${url}/tasks`;

  return Vue.prototype.axios.get(requestUrl, options).then(response => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return Vue.prototype.axios
    .get(`${url}/tasks/${id}`, options)
    .then(response => {
      let task = jsona.deserialize(response.data);
      delete task.links;
      return task;
    });
}

function add(task) {
  const payload = jsona.serialize({
    stuff: task,
    includeNames: null
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return Vue.prototype.axios
    .post(`${url}/tasks?include=customer`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(task) {
  const payload = jsona.serialize({
    stuff: task,
    includeNames: []
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return Vue.prototype.axios
    .patch(`${url}/tasks/${task.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return Vue.prototype.axios.delete(`${url}/tasks/${id}`, options);
}

export default {
  list,
  get,
  add,
  update,
  destroy
};
